module.exports = __webpack_public_path__ + "img/indonesia-flag.5c807c0c.png";